import { imagePlaceholder } from "@/lib/imagePlaceholder";
import Image from "next/image";
import React from "react";
// Props for Image Component
type ImageProps = {
  src: string;
  alt: string;
};

function areImagePropsEqual(prev: ImageProps, next: ImageProps) {
  return prev.src === next.src && prev.alt === next.alt;
}

const productImage: React.FC<ImageProps> = ({ src, alt }) => {
  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: "100%",
        overflow: "hidden",
        borderRadius: "inherit",
      }}
    >
      <Image
        src={src}
        alt={alt}
        placeholder={imagePlaceholder}
        fill
        sizes="(max-width: 420px) 50vw, (max-width: 768px) 33vw, (max-width: 1280px) 25vw, 20vw"
        quality={90}
        loading="lazy"
        style={{
          objectFit: "cover",
        }}
      />
    </div>
  );
};
export const ProductImageComponent = React.memo(productImage, areImagePropsEqual);
